module.exports = __webpack_public_path__ + "img/ic_tripadvisor-1.5.4faf5939.svg";